export default __webpack_public_path__ + "static/media/nextIcon.06b0fae1.svg";